import React, { CSSProperties } from 'react';
import { ChevronDownUniversal, ChevronTopUniversal } from '@duxton-web/icons';
import { Button } from '@duxton-web/ui';

import { useRolloutContext } from '@/contexts/RolloutContext';

interface ReorderButtonProps {
  rolloutIndex: number;
  disabled: boolean;
  onReorderUpClick: () => void;
  onReorderDownClick: () => void;
}

const defaultInlineStyle: CSSProperties = {
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
};

export default function ReorderButtonGroup({
  rolloutIndex,
  disabled,
  onReorderUpClick = () => {},
  onReorderDownClick = () => {},
}: ReorderButtonProps) {
  if (disabled) return null;

  const rolloutContext = useRolloutContext();
  const rolloutTargetsLength = rolloutContext?.rollout?.rollouts?.length ?? 0;

  const shiftUpBottonStyle = {
    ...defaultInlineStyle,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: 0,
  };

  if (rolloutIndex === rolloutTargetsLength - 1 && rolloutTargetsLength > 1) {
    delete shiftUpBottonStyle.borderRight;
  }

  return (
    <div style={{ display: 'flex' }}>
      <Button
        size="small"
        shape="default"
        onClick={(e) => {
          e.stopPropagation();

          onReorderUpClick();
        }}
        disabled={rolloutIndex === 0}
        icon={<ChevronTopUniversal />}
        style={{
          ...shiftUpBottonStyle,
        }}
      />
      <Button
        size="small"
        shape="default"
        disabled={
          rolloutIndex === rolloutTargetsLength - 1 ||
          rolloutTargetsLength === 0
        }
        onClick={(e) => {
          e.stopPropagation();

          onReorderDownClick();
        }}
        icon={<ChevronDownUniversal />}
        style={{
          ...defaultInlineStyle,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      />
    </div>
  );
}
